import { createStore, del, get, set } from 'idb-keyval'
import type { GroupSnapshot } from '../../../types'

/**
 * Lokální kopie posledního známého stavu skupiny.
 *
 * Server zůstává jediným zdrojem pravdy - cache slouží jen k tomu, aby se
 * aplikace okamžitě zobrazila a fungovala i bez připojení. Aktuálnost se
 * ověřuje porovnáním čísla revize.
 */
const store = createStore('splitup', 'snapshots')

export type CachedSnapshot = {
    snapshot: GroupSnapshot
    /** Kdy byl snímek stažen ze serveru. */
    storedAt: string
}

/**
 * Verze tvaru snímku. Zvedá se, když snímek dostane pole, bez kterých by
 * starší uložená kopie v UI chyběla (v2: rozpad bilancí a celkové útraty) -
 * stará kopie se pak nenajde a stáhne se nová.
 */
const VERZE_SNIMKU = 2

function key(groupId: string): string {
    return `group:v${VERZE_SNIMKU}:${groupId}`
}

export async function readCachedSnapshot(groupId: string): Promise<CachedSnapshot | undefined> {
    try {
        return await get<CachedSnapshot>(key(groupId), store)
    } catch {
        // Prohlížeč může mít IndexedDB zakázanou (anonymní okno, přísné nastavení).
        return undefined
    }
}

export async function writeCachedSnapshot(groupId: string, snapshot: GroupSnapshot): Promise<void> {
    try {
        await set(key(groupId), { snapshot, storedAt: new Date().toISOString() } satisfies CachedSnapshot, store)
    } catch {
        // Zaplněné úložiště nesmí shodit aplikaci - cache je jen pohodlí navíc.
    }
}

export async function clearCachedSnapshot(groupId: string): Promise<void> {
    try {
        await del(key(groupId), store)
    } catch {
        // Nic k řešení - cache je nepovinná.
    }
}
